<template>
    <v-card class="my-1" :loading="loading" variant="outlined" >
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="12">
                    <!-- eslint-disable -->
                    <v-text-field
                        @keypress.enter="updateItem({id: item.id, titulo: item.titulo})"
                        v-model="item.titulo"
                        placeholder="Título da Lista"
                        messages="Ao digitar o título pressione ENTER para salvar"
                        :disabled="$store.state.checklistdb.loading_id === `update-lista-${item.id}`">
                        <template v-slot:prepend-inner>
                            <span class="text-grey">Título:</span>
                        </template>
                        <template v-slot:append>
                            <v-btn icon title="Salvar" color="success"
                                :loading="$store.state.checklistdb.loading_id === `update-lista-${item.id}`"
                                @click="updateItem({id: item.id, titulo: item.titulo})">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                    <v-row>
                        <v-col cols="12" sm="5">
                            <div>
                                <div>
                                    <span class="text-grey">Qtde Itens: </span>
                                    <!-- <b>{{item.materiais_object.length}} itens</b> -->
                                    <b>{{item.qtde_itens}} itens</b>
                                </div>
                                <div>
                                    <span class="text-grey">Valor Total: </span>
                                    <b>{{item.total_lista_real}}</b>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="7">
                            <div class="mt-2" style="display: flex;place-content: space-between;text-align:center">
                                <span>
                                    <v-btn icon :color="item.ativo ? 'success': 'error'"
                                        :disabled="$store.state.checklistdb.loading_id === `update-lista-${item.id}`"
                                        @click="toggleActivate({id: item.id, ativo: !item.ativo})"
                                        :title="'Clique para '+(item.ativo ? 'desativar': 'reativar')+' Lista'">
                                        <v-icon>{{item.ativo ? 'mdi-check': 'mdi-close'}}</v-icon>
                                    </v-btn>
                                    &nbsp;<b v-text="item.ativo ? 'Ativada': 'Desativada'"></b>
                                </span>
                                <span>
                                    <v-btn icon color="info"
                                        @click="onClickItem"
                                        title="Clique para acessar os itens da lista">
                                        <v-icon>mdi-sitemap</v-icon>
                                    </v-btn>
                                    &nbsp;<b v-text="'Itens'"></b>
                                </span>
                                <span>
                                    <v-btn icon color="error"
                                        :loading="$store.state.checklistdb.loading_id === `delete-lista-${item.id}`"
                                        @click="deleteItem"
                                        title="Clique para remover esta lista">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                    &nbsp;<b v-text="'Remover'"></b>
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <helper-gdb text="ItemListaPesquisa" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
        </v-card-text>
    </v-card>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    props: {
        item: {
            required: true,
        },
        loading: {
            default: false
        }
    },
    mounted(){
    },
    data: ()=> ({
    }),
    methods: {
        ...mapActions(['UpdateCheckList']),
        ...mapActions(['DeleteCheckList']),
        onClickItem(){
            this.$emit('on-click-item', this.item)
        },
        async updateItem(payload){
            const updated = await this.UpdateCheckList(payload)
            if(!updated) return
            this.$emit('on-updated', true)
        },
        toggleActivate(payload){
            const confirma = confirm(`Confirma a ${payload.ativo ? 'ativação': 'desativação'} da lista?`)
            if (!confirma) return
            this.updateItem(payload)
        },
        async deleteItem(){
            const confirma = confirm('Tem certeza que deseja remover a lista ' + this.item.titulo)
            if (!confirma) return
            const deleted = await this.DeleteCheckList(this.item)
            if(!deleted) return
            this.$emit('on-deleted', true)
        },
    },
    watch: {
        // item:{
        //     handler(value){
        //         const prop = value
        //         this.item = prop
        //     }, deep: true
        // }
    }
}
</script>
<style>
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
}
</style>